import { Component, OnInit, inject } from '@angular/core';

import { UserDocumentsComponent, UserDocumentsService } from '@frontend/vanilla/features/user-documents';

import { AccountMenuItemBase } from '../../account-menu-item-base';
import { AccountMenuWidgetComponent } from './widget.component';

@Component({
    imports: [AccountMenuWidgetComponent, UserDocumentsComponent],
    selector: 'vn-am-documents-widget',
    templateUrl: 'documents-widget.html',
})
export class DocumentsWidgetComponent extends AccountMenuItemBase implements OnInit {
    userDocumentsService = inject(UserDocumentsService);

    ngOnInit() {
        this.userDocumentsService.refresh();
    }
}
